import { AnalyticsService } from '@app/shared/modules/analytics/services/analytics.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { LanguageService } from './../../../../core/language/services/language.service';
import { SmallBizStoreService } from './../../stores/small-biz-store.service';
import { EvcSmallBizQuoteHelper } from './../../services/quote-helper.service';
import { UntypedFormBuilder, Validators, UntypedFormGroup } from '@angular/forms';
import { EvsbMailOfferFormModel } from './evsb-mail-offer-form.model';
import { Component, OnInit } from '@angular/core';
import { EvsbMailOfferFormMapper } from './evsb-mail-offer-form.mapper';
import { EvcApiService } from '@app/shared/modules/evc-api/services/evc-api.service';
import {
  EmailValidator,
  normalizePhoneNumber,
  normalizeVATNumber,
  PhoneValidator,
  VatValidator,
} from '@springbox/validators';
import { PartnerUI } from '@app/shared/modules/evc-api/models/partner-ui.interface';
import { PartnerService } from 'src/app/modules/evc-quote/services/partner/partner.service';

@Component({
  selector: 'evsb-mail-offer-form',
  templateUrl: './evsb-mail-offer-form.component.html',
  styleUrls: ['./evsb-mail-offer-form.component.scss'],
})
export class EvsbMailOfferFormComponent implements OnInit {
  public model: EvsbMailOfferFormModel;
  public form: UntypedFormGroup;
  public formSubmitted = false;

  private partner: PartnerUI;

  constructor(
    private mapper: EvsbMailOfferFormMapper,
    private fb: UntypedFormBuilder,
    private evcSmallBizQuoteHelper: EvcSmallBizQuoteHelper,
    private store: SmallBizStoreService,
    private languageService: LanguageService,
    private evcApiService: EvcApiService,
    private router: Router,
    private modal: NgbModal,
    private analyticsService: AnalyticsService,
    private partnerService: PartnerService
  ) {
    this.partnerService.restoredPartner$.subscribe((partner: PartnerUI) => {
      if (partner) {
        this.partner = partner;
      }
    });
  }

  ngOnInit(): void {
    this.model = this.mapper.getModel();
    this.form = this.buildForm();
  }

  public async submit() {
    this.formSubmitted = true;
    if (this.form.valid) {
      const sendOfferOnly = true;
      const createQuoteDto = await this.evcSmallBizQuoteHelper.convertSimulationToQuote(
        {
          vatNumber: normalizeVATNumber(this.form.get('vatNumber').value),
          company: this.form.get('company').value,
          firstName: this.form.get('firstName').value,
          lastName: this.form.get('lastName').value,
          telephone: normalizePhoneNumber(this.form.get('telephone').value),
          email: this.form.get('email').value,
          alreadyClient: this.form.get('alreadyClient').value,
        },
        this.store.model,
        undefined,
        sendOfferOnly,
        this.partner,
        this.languageService.getLanguage()
      );

      // TODO: navigate to loading and then to success page
      this.evcApiService.createQuote(createQuoteDto).subscribe(
        (result) => {
          this.modal.dismissAll();
          this.router.navigate(['/thank-you-mail'], { skipLocationChange: true });

          this.analyticsService.push({
            event: 'email-confirm',
            eventCategory: 'b-to-b-ev-simulator',
            eventAction: 'quote-request',
            eventLabel: 'send-email-confirm',
            simulator: {
              leadId: result.id,
            },
          });
        },
        (error) => {
          alert('Something went wrong. Please try again.');
          console.error(error);
        }
      );
    }
  }

  public buildForm(): UntypedFormGroup {
    return this.fb.group({
      vatNumber: this.fb.control(this.model.vatNumber, [Validators.required, VatValidator.validate]),
      company: this.fb.control(this.model.company, [Validators.required]),
      firstName: this.fb.control(this.model.firstName, [Validators.required]),
      lastName: this.fb.control(this.model.lastName, [Validators.required]),
      telephone: this.fb.control(this.model.telephone, [Validators.required, PhoneValidator.validate]),
      email: this.fb.control(this.model.email, [Validators.required, EmailValidator.validate]),
      alreadyClient: this.fb.control(this.model.alreadyClient, []),
      consent: this.fb.control(this.model.consent, [Validators.requiredTrue]),
    });
  }

  public invalid(name: string): boolean {
    return this.form.get(name).invalid && (this.form.get(name).dirty || this.formSubmitted);
  }

  public normalizeVatNumber() {
    const value = this.form.get('vatNumber').value;
    this.form.get('vatNumber').setValue(normalizeVATNumber(value), { onlySelf: true, emitEvent: false });
  }

  public normalizePhoneNumber() {
    const value = this.form.get('telephone').value;
    this.form.get('telephone').setValue(normalizePhoneNumber(value), { onlySelf: true, emitEvent: false });
  }
}
